import { Suspense } from "react";
import { useSuspenseQuery } from "@tanstack/react-query";
import { LoadingScreen } from "@/components/ui/loading-screen";
import { EcosuiteErrorBoundary } from "@/components/error-boundary";
import RootUserLayout from "../layout";
import { organizationsQueryOptions } from "../service/organization";
import { OrganizationsDialogs } from "./components/organizations-dialogs";
import { OrganizationsPrimaryButtons } from "./components/organizations-primary-buttons";
import { OrganizationsTable } from "./components/organizations-table";

function OrganizationsContent() {
  const organizationsQuery = useSuspenseQuery(organizationsQueryOptions);
  const organizations = organizationsQuery.data;

  return (
    <>
      <OrganizationsTable organizations={organizations} />
      <OrganizationsDialogs />
    </>
  );
}

export default function Organizations() {
  return (
    <RootUserLayout
      pageTitle="Organization List"
      pageDescription="View and manage your organizations here."
      rightContent={<OrganizationsPrimaryButtons />}
    >
      <Suspense
        fallback={
          <LoadingScreen
            text="Loading Organizations..."
            className="h-[calc(100vh-180px)]"
          />
        }
      >
        <EcosuiteErrorBoundary>
          <OrganizationsContent />
        </EcosuiteErrorBoundary>
      </Suspense>
    </RootUserLayout>
  );
}
